export function hasFamilyTicket(tickets) {
  const pattern = /^Family Pass/g

  return tickets
    .some((ticket) => ticket.quantity > 0 && pattern.test(ticket.title));
}

export function calculateFamilyAndKidDiscountAmount(ticketTitle, tickets) {
  const pattern = /^Kids/g
  if (hasFamilyTicket(tickets) && ticketTitle?.search(pattern) !== -1) {
    // Discount 4$
    return 4;
  }

  // if more than 3 tickets
  if(tickets && tickets.reduce((m,t) => m + t.quantity, 0) >= 3) {
    // Give 2$ discount to all tickets
    return 2;
  }

  return 0;
}
